import { render, staticRenderFns } from "./customerReport.vue?vue&type=template&id=b9dbb8d0&scoped=true"
import script from "./customerReport.vue?vue&type=script&lang=js"
export * from "./customerReport.vue?vue&type=script&lang=js"
import style0 from "./customerReport.vue?vue&type=style&index=0&id=b9dbb8d0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9dbb8d0",
  null
  
)

export default component.exports